export default __webpack_public_path__ + "static/webohooks-c9fcc8dd779c8caa5f50272fe8655ee4.webp";